module.exports = __webpack_public_path__ + "files/6cd0396a801411b7a8a6b45f541ad3cc.png";